"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opportunityEvaluationCriteriaResponseSchema = exports.candidateOpportunityEvaluationResponseSchema = exports.candidateOpportunityEvaluationCriterionKeys = exports.candidateOpportunityScoringResponseSchema = exports.candidateOpportunityScoringResultSchema = exports.candidateOpportunityScoringScoresSchema = void 0;
const zod_1 = require("zod");
const candidateOpportunityScoreValueSchema = zod_1.z.number().min(0).max(100);
exports.candidateOpportunityScoringScoresSchema = zod_1.z
    .object({
    contract: candidateOpportunityScoreValueSchema.nullable().optional(),
    location: candidateOpportunityScoreValueSchema.nullable().optional(),
    formations: candidateOpportunityScoreValueSchema.nullable().optional(),
    habilitations: candidateOpportunityScoreValueSchema.nullable().optional(),
    languages: candidateOpportunityScoreValueSchema.nullable().optional(),
    tools: candidateOpportunityScoreValueSchema.nullable().optional(),
    domains: candidateOpportunityScoreValueSchema.nullable().optional(),
    sectors: candidateOpportunityScoreValueSchema.nullable().optional(),
    experience: candidateOpportunityScoreValueSchema.nullable().optional(),
})
    .describe('Sous-scores optionnels par critere d adequation');
exports.candidateOpportunityScoringResultSchema = zod_1.z.object({
    boondId: zod_1.z.string(),
    score: candidateOpportunityScoreValueSchema,
    scores: exports.candidateOpportunityScoringScoresSchema.nullable().optional(),
    justification: zod_1.z.string(),
    strengths: zod_1.z.array(zod_1.z.string()).optional(),
    weaknesses: zod_1.z.array(zod_1.z.string()).optional(),
    risks: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.candidateOpportunityScoringResponseSchema = zod_1.z.object({
    results: zod_1.z.array(exports.candidateOpportunityScoringResultSchema).min(1),
});
exports.candidateOpportunityEvaluationCriterionKeys = [
    'criterion-01',
    'criterion-02',
    'criterion-03',
    'criterion-04',
    'criterion-05',
];
const candidateOpportunityEvaluationResultSchema = zod_1.z.object({
    key: zod_1.z.enum(exports.candidateOpportunityEvaluationCriterionKeys),
    score: zod_1.z.number().min(0).max(100),
    justification: zod_1.z.string().trim().min(1),
});
exports.candidateOpportunityEvaluationResponseSchema = zod_1.z
    .object({
    results: zod_1.z.array(candidateOpportunityEvaluationResultSchema).length(5),
    conclusion: zod_1.z.string().trim().min(1),
})
    .superRefine((value, context) => {
    const keys = value.results.map((result) => result.key);
    if (new Set(keys).size !== exports.candidateOpportunityEvaluationCriterionKeys.length) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['results'],
            message: 'Chaque cle de critere doit apparaitre exactement une fois',
        });
    }
});
const opportunityEvaluationCriterionSchema = zod_1.z.object({
    label: zod_1.z.string().trim().min(1),
    description: zod_1.z.string().trim().min(1),
});
exports.opportunityEvaluationCriteriaResponseSchema = zod_1.z
    .object({
    criteria: zod_1.z.array(opportunityEvaluationCriterionSchema).length(5),
})
    .superRefine(({ criteria }, context) => {
    const normalizedLabels = criteria.map(({ label }) => label.toLocaleLowerCase().replace(/\s+/g, ' ').trim());
    if (new Set(normalizedLabels).size !== normalizedLabels.length) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['criteria'],
            message: 'Les cinq criteres doivent etre distincts',
        });
    }
});
